import { Logout, usePermissions, UserMenu } from "react-admin"
import { Divider } from "@mui/material"
import UserDataMenu from "./userMenu/UserDataMenu"
import UserLogoMenu from "./userMenu/UserLogoMenu"
import UserMailServiceConfigMenu from "./userMenu/UserMailServiceConfig"
import UserTextModelMenu from "./userMenu/UserTextModelMenu"
import { Permissions } from "../authentication/Permissions"
import SubscriptionMenuItem from "./userMenu/SubscriptionMenuItem"

const CustomUserMenu = () => {

  const { isLoading, permissions } = usePermissions<Permissions>()
  const fffBaseUrl = process.env.REACT_APP_FREE_FIBU_BASE_URL ? process.env.REACT_APP_FREE_FIBU_BASE_URL : 'http://localhost:10101/fff'

  if(isLoading) return null

  return (
    <UserMenu>
      <SubscriptionMenuItem />
      <Divider />
      <UserDataMenu />
      <UserLogoMenu />
      <UserTextModelMenu />
      <UserMailServiceConfigMenu />
      <Logout 
        redirectTo={permissions.redirectToFff ? `${fffBaseUrl}/logout` : undefined} 
      />
    </UserMenu>    
  )
}

export default CustomUserMenu